import { Props } from './types';
import { Text } from '~components';
import * as Styled from './styled';

function OrderStatus({ status }: Props) {
  return (
    <>
      <Text variant="h600">Situação geral da solicitação:</Text>
      <Styled.Container $variant={status}>
        {status === 'pending' ? (
          <>
            <Styled.Search />
            <Styled.Column>
              <Styled.StatusTitle color="neutral-strong">
                Documentos em análise
              </Styled.StatusTitle>
              <Styled.StatusDescription>
                Agora é com a gente! Estamos analisando os documentos enviados e
                assim que finalizarmos, enviaremos um e-mail para o(s)
                representante(s).
              </Styled.StatusDescription>
            </Styled.Column>
          </>
        ) : (
          <>
            <>
              <Styled.RedCancel />
              <Styled.Column>
                <Styled.StatusTitle color="danger-strong">
                  Solicitação não aprovada
                </Styled.StatusTitle>
                <Styled.StatusDescription>
                  Infelizmente não foi possível dar continuidade a sua
                  solicitação.
                </Styled.StatusDescription>
                <Styled.StatusDescription $isMarginParagraph>
                  Para mais informações entre em contato com a FreteBras pelos
                  nossos canais de atendimento:
                </Styled.StatusDescription>
                <Styled.StatusDescription
                  $isMarginParagraph
                  variant="b400-bold"
                  color="neutral-strong"
                >
                  SAC: 0800 555 0073
                </Styled.StatusDescription>
                <Styled.StatusDescription
                  variant="b400-bold"
                  color="neutral-strong"
                >
                  Ouvidoria: (11) 4004-4004
                </Styled.StatusDescription>
              </Styled.Column>
            </>
          </>
        )}
      </Styled.Container>
    </>
  );
}

export default OrderStatus;
